module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasExtras) ? [_c('table', {
    staticClass: "w-100 dark mb-4"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.extrasArrayToAdd), function(extra) {
    return (extra.component.componentType === 0) ? _c('tr', {
      staticClass: "extraRow border-bottom-light border-top-light"
    }, [_c('td', {
      staticClass: "darker fs-large pl-2"
    }, [_vm._v(_vm._s(extra.component.name) + " - " + _vm._s(extra.componentPrice.name))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.showAvailability(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.formatPrice(extra.componentPrice.grossprice)) + " €")]), _vm._v(" "), _c('td', {
      staticClass: "d-flex flex-row justify-content-center py-2"
    }, [_c('span', {
      staticClass: "border-light py-2 px-3 radius-normal mx-2 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd2('remove', extra)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-minus dark fs-smaller m-0"
    })]), _vm._v(" "), _c('input', {
      staticClass: "text-center fs-larger px-1 py-0 bg-lighter darker",
      staticStyle: {
        "width": "2.2rem"
      },
      attrs: {
        "type": "number",
        "placeholder": "0",
        "min": "0"
      },
      domProps: {
        "value": extra.quantityToAdd
      },
      on: {
        "input": function($event) {
          return _vm.quantityChanged(extra, $event.target.value)
        },
        "focus": function($event) {
          return _vm.extraFocused(extra)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "border-light py-2 px-3 radius-normal mx-2 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd2('add', extra)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-add dark fs-smaller m-0"
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', {
    staticClass: "fs-large"
  }, [_c('th', {
    staticClass: "pt-2 pl-2 extraNameWidth"
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2 text-center"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.addedExtrasTotalPrice)) + " €")]), _vm._v(" "), _c('th', {
    staticClass: "pt-2 addRemoveWidth text-center"
  }, [_vm._v(_vm._s(_vm.totalExtras))])])], 2)] : _c('div', {
    staticClass: "fs-large dark text-center p-2"
  }, [_vm._v("\n        There are no extras to show\n    ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "fs-small"
  }, [_c('th', {
    staticClass: "extraNameWidth"
  }), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Availability")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("Price/unit")]), _vm._v(" "), _c('th', {
    staticClass: "addRemoveWidth",
    staticStyle: {
      "width": "200px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-495df904", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495df904"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/AddExtra/AddExtra.vue
// module id = 1697
// module chunks = 0